
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roadmap",
      function () {
        return require("private-next-pages/roadmap/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roadmap"])
      });
    }
  